/**
 * @name NotificationsService
 * @description Servicio para la gestión de notificaciones
 * @author Ricardo Guerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Notificación Endpoint
const BASE_URL = `${Environment.getCurrent().endpoints.notifications}/Notificacion`;

/**
 * Consulta notificaciones del usuario
 * @param {number} IdEmpleado
 * @return {any} promise
 */
const get = (employeeId) => {
  let URL = `${BASE_URL}?IdEmpleado=${employeeId}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Añade una notficación
 * @param {object} request
 * @return {any} promise
 */
const post = (request) => {
  return axios.post(BASE_URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Añade una notificación para muchos usuarios
 * @param {object} request
 * @return {any} promise
 */
const postMassive = (request) => {
  let URL = `${BASE_URL}/Masivo`;

  return axios.post(URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Actualiza una notificación
 * @param {object} request { id, read }
 * @return {any} promise
 */
const patch = (request) => {
  let URL = `${BASE_URL}/${request.id}`;

  return axios.patch(URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Actualiza el estatus leido o visto de todas las notificaciones
 * @param {object} request { seen, read }
 * @return {any} promise
 */
const put = (request) => {
  let URL = request.seen ? `${BASE_URL}?Visto=true` : `${BASE_URL}?Leido=true`;

  return axios.put(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Elimina una notificación
 * @param {number} notificationId
 * @return {any} promise
 */
const _delete = (notificationId) => {
  let URL = `${BASE_URL}/${notificationId}`;

  return axios.delete(URL).then(({ data }) => {
    return data;
  });
};

export const NotificationsService = {
  get,
  post,
  postMassive,
  patch,
  put,
  delete: _delete
};
